<template>
  <div>
    <h1>Ajouter une activité au parcours clinique</h1>
    <form-parcoursclinique :ismeddetail="ismeddetail" ref="formPc">
    </form-parcoursclinique>
    <el-divider></el-divider>
    <div style="margin-top: 8px">
      <el-button type="primary" :disabled="isSaving" @click="onSubmit"
        >Enregistrer</el-button
      >
      <el-button @click="onCancel">Annuler</el-button>
    </div>
  </div>
</template>
<script>
import FormParcoursclinique from "@/components/rh/ui/form/FormParcoursclinique";
import { trimStringInObj } from "@/fonctions";

export default {
  components: { "form-parcoursclinique": FormParcoursclinique },

  data() {
    return {
      isSaving: false,
    };
  },
  props: {
    ismeddetail: Boolean,
    routes: Object,
  },
  created() {
    // récupère l'id du médecin si dans détail médecin
    const idMed = this.$route.params.idmed;
    this.$store.commit("pc/resetParcoursclinique", idMed);
  },
  computed: {
    parcourscliniqueCreateStatus() {
      // 1 = action en cours, 2 = succès, 3 = échec
      return this.$store.state.pc.parcourscliniqueCreateStatus;
    },
  },
  methods: {
    onSubmit() {
      this.$refs.formPc.$refs.formParcoursclinique.validate((valid) => {
        if (valid) {
          var pcdata = this.$store.state.pc.parcoursclinique;

          // enlever les espaces avant et après dans les string
          trimStringInObj(pcdata);

          // vérifie si l'activité existe déjà pour le médecin
          const pcInBD = this.$store.getters["pc/ParcourscliniqueInBD"];
          const doublon =
            pcInBD.filter(
              (m) =>
                m[1] == pcdata.id_med &&
                m[2] == pcdata.id_activite &&
                m[3] == pcdata.debut_date
            ).length > 0;
          if (doublon) {
            this.$alert(
              "La même activité débutant à la même date existe déjà pour ce médecin",
              "Attention",
              {
                confirmButtonText: "Fermer",
                dangerouslyUseHTMLString: true,
              }
            );
            return false;
          } else {
            // si plus d'erreur lance la création du nouvel enregistrement
            this.$store.dispatch("pc/createParcoursclinique", pcdata);
          }
        } else {
          return false;
        }
      });
    },
    onCancel() {
      // retourne à la liste des parcourscliniques
      this.$router.push(this.routes.tolist);
    },
  },
  watch: {
    parcourscliniqueCreateStatus() {
      // gère les messages et la navigation après soumission du formulaire
      if (this.parcourscliniqueCreateStatus == 2) {
        // message succès
        this.$message({
          message: "L'activité a été ajouté-e à la base de donnée",
          type: "success",
        });

        // va au formulaire d'édition du parcoursclinique
        this.$router.push(this.routes.toedit);
      } else if (this.parcourscliniqueCreateStatus == 3) {
        this.isSaving = false;
        // message échec
        this.$message.error({ message: "Echec de l'enregistrement !" });
      } else if (this.parcourscliniqueCreateStatus == 1) {
        this.isSaving = true;
      } else if (this.parcourscliniqueCreateStatus == 0) {
        this.isSaving = false;
      }
    },
  },
};
</script>
